import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { CategoriesService } from '../home/categories/services/categories.service';
import { PlansService } from '../home/services/plans.service';
import { EmployeeService } from '../home/services/employee.service';
import { catchError, from, of } from 'rxjs';

export const PlansResolverService: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(CategoriesService).getPlans()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};

export const DetailPlansResolverService: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(PlansService).get_detail_plans()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};

export const EmployeePlanResolver: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(EmployeeService).get_employee_plan()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};

export const EmployeeChangePlanResolver: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(EmployeeService).get_employee_cambio_plan()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};